<template>
    <div class="grid grid-cols-1 gap-x-4 gap-y-3 px-4 py-2 sm:grid-cols-2 sm:px-6">
        <h3
            :class="[
                'col-span-2 pb-1 text-base font-semibold',
                { 'required': isRequiredNaturalComplianceProfileAttribute('tax_situation', 'tax_situation') },
            ]">
            {{ $t('country_tax_residencies.tax_situation') }}
        </h3>
        <BaseInputCheckbox
            v-model="account.compliance_profiles.esac.tax_situation.tax_situation.capital_gains"
            :disabled="isNaturalComplianceProfileLocked()"
            :label="$t('country_tax_residencies.capital_gains')"
            name="tax_situation.tax_situation.capital_gains"></BaseInputCheckbox>
        <BaseInputCheckbox
            v-model="account.compliance_profiles.esac.tax_situation.tax_situation.foreign_assets"
            :disabled="isNaturalComplianceProfileLocked()"
            :label="$t('country_tax_residencies.foreign_assets_ownership')"
            name="tax_situation.tax_situation.foreign_assets"></BaseInputCheckbox>
    </div>
</template>

<script setup lang="ts">
import BaseInputCheckbox from '../../../../base/BaseInputCheckbox.vue'
import { isRequiredNaturalComplianceProfileAttribute } from '../forms'
import {
    isNaturalComplianceProfileLocked,
    usePersonalAccountDataState,
} from '../../../../../utilities/account/useAccountDataPersonal'

const { naturalProfile: account } = usePersonalAccountDataState()
</script>
